import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getReEstimation,
  reEstimationListSuccessful,
  reEstimationAddSuccessful,
  isModelVisible,
  reEstimationByIDSuccessful
} from "./reEstimationSlice";

// Auth Related Methods

import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
  getList
} from "../../../helpers/Helper";

import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";

function* ReEstimation({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/stocktransfer/reestimationamount/", params);
    yield put(reEstimationListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* AddReEstimation({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/stocktransfer/reestimationamount/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Re-Estimation Added Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getReEstimation({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to added Re-Estimation. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(reEstimationAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/stocktransfer/reestimationamount/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Re-Estimation Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getReEstimation({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Re-Estimation. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(reEstimationAddSuccessful(null));
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeletereEstimation({ payload }) {
  var areaID = payload;
  try {
    const response = yield call(postDelete, "/stocktransfer/reestimationamount/" + areaID);

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Re-Estimation has been deleted!
            </p>
          </div>
        ),
      });
      yield put(getReEstimation({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Re-Estimation has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

function* ReEstimationByID({ payload }) {
  try {
    const response = yield call(
      getList,
      "/stocktransfer/reestimationamount/" + payload,
      {}
    );
    yield put(reEstimationByIDSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}


function* watchGetReEstimation() {
  yield takeEvery("reEstimation/getReEstimation", ReEstimation);
}

export function* watchAddreEstimation() {
  yield takeEvery("reEstimation/reEstimationAdd", AddReEstimation);
}

export function* watchGetReEstimationByID() {
  yield takeEvery("reEstimation/getReEstimationByID", ReEstimationByID);
}

export function* watchReEstimationDelete() {
  yield takeEvery("reEstimation/reEstimationDelete", DeletereEstimation);
}



function* ReEstimationSaga() {
  yield all([
    fork(watchGetReEstimation),
    fork(watchAddreEstimation),
    fork(watchGetReEstimationByID),
    fork(watchReEstimationDelete)
  ]);
}

export default ReEstimationSaga;
